export const vacancyCardSmallMapUpdatedEvent = 'displayedVacancyUpdated'
